
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <div className="flex items-center gap-3 cursor-pointer" onClick={() => scrollToSection('hero')}>
            <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-emerald-600 to-emerald-700 rounded-full">
              <i className="ri-plant-line text-2xl text-white"></i>
            </div>
            <h1 className={`text-xs sm:text-xl font-bold transition-colors leading-tight whitespace-nowrap ${isScrolled ? 'text-gray-900' : 'text-white'}`} style={{ fontFamily: 'Inter, sans-serif' }}>
              Atlanta Stump Grinding Pros
            </h1>
          </div>

          <div className="hidden md:flex items-center gap-8">
            <button onClick={() => scrollToSection('services')} className={`text-sm font-medium transition-colors hover:text-emerald-600 whitespace-nowrap cursor-pointer ${isScrolled ? 'text-gray-700' : 'text-white'}`}>
              Services
            </button>
            <Link to="/stump-grinding" className={`text-sm font-medium transition-colors hover:text-emerald-600 whitespace-nowrap cursor-pointer ${isScrolled ? 'text-gray-700' : 'text-white'}`}>
              Stump Grinding
            </Link>
            <button onClick={() => scrollToSection('contact')} className={`text-sm font-medium transition-colors hover:text-emerald-600 whitespace-nowrap cursor-pointer ${isScrolled ? 'text-gray-700' : 'text-white'}`}>
              Contact
            </button>
            <button 
              onClick={() => scrollToSection('contact')} 
              className="px-6 py-2.5 bg-emerald-600 text-white text-sm font-semibold rounded-full hover:bg-emerald-700 transition-all whitespace-nowrap cursor-pointer flex items-center gap-2"
            >
              Get a Quote
              <i className="ri-arrow-right-line"></i>
            </button>
          </div>

          <button 
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
          >
            <i className={`text-2xl ${isScrolled ? 'text-gray-900' : 'text-white'} ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-white border-t border-gray-200 shadow-lg">
          <div className="px-6 py-4 space-y-3">
            <button onClick={() => scrollToSection('services')} className="block w-full text-left py-2 text-sm font-medium text-gray-700 hover:text-emerald-600 cursor-pointer">
              Services
            </button>
            <Link to="/stump-grinding" onClick={() => setIsMobileMenuOpen(false)} className="block w-full text-left py-2 text-sm font-medium text-gray-700 hover:text-emerald-600 cursor-pointer">
              Stump Grinding
            </Link>
            <button onClick={() => scrollToSection('contact')} className="block w-full text-left py-2 text-sm font-medium text-gray-700 hover:text-emerald-600 cursor-pointer">
              Contact
            </button>
            <button onClick={() => scrollToSection('contact')} className="block w-full text-center py-2.5 bg-emerald-600 text-white text-sm font-semibold rounded-full hover:bg-emerald-700 transition-all cursor-pointer">
              Get a Quote
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}
